import HomePageComponent from "@dogstrust/uk/staticPageTemplates/HomePage/HomePage";
import { graphql } from "gatsby";
import React, { useEffect, useState } from "react";
export { Head } from "@dogstrust/uk/staticPageTemplates/HomePage/HomePage";

interface HomePageProps {
	data: Queries.HomePageQuery;
}
const HomePage: React.FC<HomePageProps> = ({
	data: {
		homePages: { nodes: homePageNodes },
		centres: { nodes: centreNodes },
	},
}) => {
	const [homePageNode, setHomepageNode] = useState(
		homePageNodes.find(
			(node: {
				field_ab_testing_key: string;
			}) => node.field_ab_testing_key === "default",
		) || homePageNodes[homePageNodes.length - 1],
	);
	useEffect(() => {
		const updateHomepageNode = () => {
			if (window.homepageABVariant) {
				const abVariant =
					homePageNodes.find(
						(node: {
							field_ab_testing_key: string;
						}) => node.field_ab_testing_key === window.homepageABVariant,
					) || homePageNodes[homePageNodes.length - 1];

				setHomepageNode(abVariant);
			} else {
				setHomepageNode(
					homePageNodes.find(
						(node: {
							field_ab_testing_key: string;
						}) => node.field_ab_testing_key === "default",
					) || homePageNodes[homePageNodes.length - 1],
				);
			}
		};
		updateHomepageNode();
	}, [homePageNodes]);

	if (!homePageNode) return null;
	return (
		<HomePageComponent data={homePageNode} allCentres={[...centreNodes]} />
	);
};

export default HomePage;

export const query = graphql`
    query HomePage {
        homePages: allNodeHomepage(filter: { status: { eq: true } }) {
            nodes {
                ...HomePageData
            }
        }
        centres: allNodeCentre {
            nodes {
                ...RehomingCentreData
            }
        }
    }
`;

export const fragment = graphql`
    fragment HomePageData on node__homepage {
        __typename
        title
        field_media
        field_content
        field_short_description
        field_embed_code
        field_meta_tags {
            ...MetaTags
        }
        field_widget_theme
        field_toggle_sombre_banner_theme
        field_ab_testing_key
        relationships {
            field_section_to_display {
                ...ParagraphSectionsData
            }
            field_featured_image {
                ...MediaImageData
            }
            field_featured_video {
                ...MediaVideoData
            }
            field_quick_links {
                ...QuickLinksUnionData
            }
        }
        field_cta {
            title
            uri
        }
    }

    fragment QuickLinksUnionData on QuickLinksUnion {
        __typename
        ...ArticleContentData
        ...LandingPageContentData
        ...TopicContentData
        ...StaticInternalPageReferenceContentData
    }

    fragment MetaTags on node__meta_tags {
        title
        description
        abstract
        keywords
        canonical_url
        robots
        og_type
        og_url
        og_title
        og_description
        og_image_url
        twitter_cards_type
        twitter_cards_description
        twitter_cards_site
        twitter_cards_title
        twitter_cards_page_url
        twitter_cards_image
    }

    fragment BreadCrumb on Breadcrumb {
        title
        url
    }
`;
